import { FC } from "react";
import { TransportSedelStatus } from "types/transportSedel.type";

interface Props {
  status: TransportSedelStatus;
}

export const TransportSedelStatusTag: FC<Props> = ({ status }) => {
  switch (status) {
    case TransportSedelStatus.Created:
      return (
        <span className="inline-flex items-center gap-x-0.5 rounded-md bg-gray-50 py-1 pl-1.5 pr-2 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-600/20">
          {/* <ClipboardIcon className="group relative -ml-1 h-3.5 w-auto rounded-sm hover:bg-indigo-600/20 sm:h-4" /> */}
          {transportSedelStatusLabel(status)}
        </span>
      );
    case TransportSedelStatus.LoadedOnTruck:
      return (
        <span className="inline-flex items-center gap-x-0.5 rounded-md bg-pink-50 py-1 pl-1.5 pr-2 text-xs font-medium text-pink-900 ring-1 ring-inset ring-pink-600/20">
          {/* <TruckIcon className="group relative -ml-1 h-3.5 w-auto rounded-sm hover:bg-pink-600/20 sm:h-4" /> */}
          {transportSedelStatusLabel(status)}
        </span>
      );

    case TransportSedelStatus.Completed:
      return (
        <span className="inline-flex items-center gap-x-0.5 rounded-md bg-cyan-50 py-1 pl-1.5 pr-2 text-xs font-medium text-cyan-900 ring-1 ring-inset ring-cyan-600/20">
          {/* <CheckCircleIcon className="group relative -ml-1 h-3.5 w-auto rounded-sm hover:bg-cyan-600/20 sm:h-4" /> */}
          {transportSedelStatusLabel(status)}
        </span>
      );
    default:
      throw Error(
        `TransportDocumentStatusTag is missing implementation for ${status}`,
      );
  }
};

export const transportSedelStatusLabel = (status: TransportSedelStatus) => {
  switch (status) {
    case TransportSedelStatus.Created:
      return "Skapad";
    case TransportSedelStatus.Completed:
      return "Slutförd";
    case TransportSedelStatus.LoadedOnTruck:
      return "Lastad";
    default:
      throw Error(
        "transportDocumentStatusLabel missing implementation for" + status,
      );
  }
};
